import { render, staticRenderFns } from "./DonationsListTable.vue?vue&type=template&id=00638239"
import script from "./DonationsListTable.vue?vue&type=script&lang=js"
export * from "./DonationsListTable.vue?vue&type=script&lang=js"
import style0 from "./DonationsListTable.vue?vue&type=style&index=0&id=00638239&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports